import { render, staticRenderFns } from "./PopupBackgroundLayer.vue?vue&type=template&id=537200e6&scoped=true&"
import script from "./PopupBackgroundLayer.vue?vue&type=script&lang=ts&"
export * from "./PopupBackgroundLayer.vue?vue&type=script&lang=ts&"
import style0 from "./PopupBackgroundLayer.vue?vue&type=style&index=0&id=537200e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537200e6",
  null
  
)

export default component.exports